<template>
  <el-row class="full-height" :gutter="10" style="margin: 0px; padding: 10px 4px">
    <el-col class="full-height" :span="8">
      <el-container class="full-height">
        <el-header height="auto" class="no-padding">
          <el-form size="small" label-position="top">

            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item label="Nome">
                  <el-input size="small" v-model="formPesquisa.nome" @keyup.enter.native="handleListarCaracteristicas"/>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row style="margin-top: 10px">
              <el-col>
                <el-button @click="limparForm" size="small" type="success">Novo</el-button>
                <el-button @click="handleListarCaracteristicas" size="small" type="primary">Pesquisar</el-button>
                <el-button @click="limparFormPesquisa" size="small" type="warning">Limpar</el-button>
              </el-col>
            </el-row>

            <el-row style="margin-top: 10px">
              <el-col>
                <span style="font-size: 14px; color: #777">{{ labelQuantidadeCatacteristica }}</span>
              </el-col>
            </el-row>
          
          </el-form>
        </el-header>
        
        <el-main style="height: 100%; padding: 0px; margin-top: 10px">
          <el-table
            @row-dblclick="handleRecuperarCaracteristica"
            :data="listaCaracteristicas"
            empty-text="Nenhuma Caracteristica"
            height="100%"
            size="small"
            highlight-current-row
            stripe
          >
            <el-table-column label="Nome" prop="nome"/>
          </el-table>
        </el-main>

      </el-container>
    </el-col>
    <el-col :span="16" class="full-height">
      <el-container class="full-height">
        <el-header height="40px" style="padding: 10px 0px">
          <span style="color: #777; font-weight: bold">
            {{ `Caracteristicas Condomínio - ${form.id === 0 ? 'Nova Caracteristica' : `${form.nome}`}` }}
          </span>
        </el-header>

        <el-main class="full-height" style="background: #FFF; padding: 10px 0px 0px 0px">
          <div class="tab-conteiner">
            <el-form 
              size="small"
              :model="form"
              ref="form"
              :rules="validacao"
              hide-required-asterisk
              :show-message="false"
            >
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item label="Nome" prop="nome">
                    <el-input size="small" v-model="form.nome"/>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-main>

        <el-footer height="52px" style="background-color: #D1D1D1; padding: 10px 10px;">
          <el-row style="height: 100%">
            <el-col :span="24" style="height: 100%">
              <el-row type="flex" justify="end" style="padding-top: 0px;">
                <el-button @click="handleGravarCaracteristica" size="small" type="success">Gravar</el-button>
                <el-button @click="confirmarRemoverCaracteristica" size="small" type="danger" v-if="caracteristicaIsSelecionada">Remover</el-button>
              </el-row>
            </el-col>
          </el-row>
        </el-footer>

      </el-container>
    </el-col>
  </el-row >
</template>

<script>
import { mapState,mapActions } from 'vuex'

export default {
  data() {
    return {
      validacao: {
        nome: [{ required: true }]
      }
    }
  },

  created() {
    this.handleListarCaracteristicas();
  },

  computed: {
    ...mapState('condominioStore', {
      form: (state) => { return state.form },
      formPesquisa: (state) => { return state.formPesquisa },
      listaCaracteristicas: (state) => { return state.caracteristicasCondominios },
      quantidadeCaracteristicas: (state) => { return state.quantidadeCaracteristicas }
    }),

    caracteristicaIsSelecionada() {
      return this.form.id !== 0;
    },

    labelQuantidadeCatacteristica() {
      switch (this.quantidadeCaracteristicas) {
        case 0:
          return 'Nenhuma caracteristica foi encontrada';
        case 1:
          return '1 caracteristica foi encontrada';
        default:
          return `${this.quantidadeCaracteristicas} caracteristicas foram encontradas`;
      }
    }
  },

  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading',
    ]),
    ...mapActions('condominioStore', [
      'listarCaracteristicas',
      'gravarCaracteristica',
      'recuperarCaracteristica',
      'removerCaracteristica',
      'limparForm',
      'limparFormPesquisa'
    ]),

    handleListarCaracteristicas() {
      const payload = { ...this.formPesquisa }

      this.showLoading();

      this.listarCaracteristicas(payload)
      .then()
      .finally(() => {
        this.hideLoading();
      });
    },

    handleGravarCaracteristica() {
      this.$refs['form'].validate(valid => {
        if(valid) {
          const payload = { ...this.form }

          this.showLoading();

          this.gravarCaracteristica(payload)
          .then(() => {
            this.$message.success('Caracteristica gravada com sucesso.')
            this.listarCaracteristicas({});
          })
          .finally(() => {
            this.hideLoading();
          });
        } else {
          this.$message.warning('Insira os campos obrigatórios')
        }
      });
    },

    handleRecuperarCaracteristica(caracteristica) {
      const payload = { id: caracteristica.id }

      this.showLoading();

      this.recuperarCaracteristica(payload)
      .then()
      .finally(() => {
        this.hideLoading();
      });
    },

    confirmarRemoverCaracteristica() {
      this.$confirm('Deseja realmente remover esta caracteristica?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.handleRemoverCaracteristica();
      }).catch(() => {})
    },

    handleRemoverCaracteristica() {
      const payload = { ...this.form }

      this.showLoading();

      this.removerCaracteristica(payload)
      .then((resposta) => {
        if(resposta.status === 'FALHA') {
          this.$message.warning(resposta.mensagem)
        } else {
          this.$message.success(resposta.mensagem)
        }
        this.listaCaracteristicas({});
      })
      .finally(() => {
        this.hideLoading();
      });
    }
  }
}
</script>